import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/settings/team')({
  // Component lazy loaded from team.lazy.tsx
});
